import axiosApiInstance from '../../interceptors/axiosApiInstance';
import { BASE_URL } from '../config';

const SettingsService = {
    getSettings: async function () {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/settings`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    updateSettings: async function (data) {
        try {
            const response = await axiosApiInstance.put(BASE_URL + `/settings`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    validateSslSettings: async function (data) {
        try {
            let formData = new FormData();
            formData.append('file', data.file);
            formData.append('password', data.password);
            const response = await axiosApiInstance.post(BASE_URL + `/settings/ssl-verify`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getPersonallization: async function () {
        try {
            const response = await axiosApiInstance.get(BASE_URL + '/settings/personalization');
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    postPersonallization: async function (data) {
        try {
            const response = await axiosApiInstance.post(BASE_URL + '/settings/personalization', data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getMail: async function () {
        try {
            const response = await axiosApiInstance.get(BASE_URL + '/settings/mail');
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    postMail: async function (data) {
        try {
            const response = await axiosApiInstance.post(BASE_URL + '/settings/mail', data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    sendMail: async function (data) {
        try {
            const response = await axiosApiInstance.post(BASE_URL + '/settings/mail/send/test', data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    resetSettings: async function () {
        try {
            const response = await axiosApiInstance.get(BASE_URL + '/settings/general/reset');
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    }
};

export default SettingsService;
